import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

let toastId = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const removeToast = useCallback((id) => {
    clearTimeout(timers.current[id]);
    delete timers.current[id];
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const addToast = useCallback((message, type = 'info', duration = 4000) => {
    const id = ++toastId;
    setToasts(prev => [...prev, { id, message, type }]);
    timers.current[id] = setTimeout(() => removeToast(id), duration);
    return id;
  }, [removeToast]);

  const toast = useCallback({
    success: (msg, dur) => addToast(msg, 'success', dur),
    error: (msg, dur) => addToast(msg, 'error', dur || 6000),
    warning: (msg, dur) => addToast(msg, 'warning', dur || 5000),
    info: (msg, dur) => addToast(msg, 'info', dur),
  }, [addToast]);

  // Make toast callable: toast.success(), toast.error(), etc.
  const api = Object.assign((msg, type, dur) => addToast(msg, type, dur), toast);

  return (
    <ToastContext.Provider value={api}>
      {children}
      <div className="toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast toast-${t.type}`} onClick={() => removeToast(t.id)}>
            <div className="toast-icon">
              {t.type === 'success' && '\u2714'}
              {t.type === 'error' && '\u2718'}
              {t.type === 'warning' && '\u26A0'}
              {t.type === 'info' && '\u2139'}
            </div>
            <div className="toast-message">{t.message}</div>
            <button className="toast-close" onClick={(e) => { e.stopPropagation(); removeToast(t.id); }}>&times;</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
